/**
 * Calculates the width of a given string when is rendered on an HTML canvas.
 * @param text input string
 * @param font the font family and size to be used
 * @returns the length of the input string
 */
const getTextWidth = (text: string, font = "14pt Proxima Nova") => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Cannot get 2D context of canvas.");
  }

  context.font = font;
  const metrics = context.measureText(text);

  return metrics.width + 10;
};

export default getTextWidth;
